<!-- <app-preloader></app-preloader> -->
<mat-progress-bar
  *ngIf="loading" color="accent" mode="indeterminate">
</mat-progress-bar>
<app-navbar *ngIf="!(location == '/error' || location == '/coming-soon')"></app-navbar>
    <router-outlet (activate)="onActivate($event)"></router-outlet>
<!-- <app-footer *ngIf="!(location == '/error' || location == '/coming-soon' || location == '/' || location == '/home' || location == '/0#' || location == '/home-one')"></app-footer> -->
<app-mini-footer *ngIf="!(location == '/error' || location == '/coming-soon')"></app-mini-footer>
